"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var colors = _interopRequireWildcard(require("@cimpress/react-components/lib/colors"));

var _emotion = require("emotion");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactDropzone = _interopRequireDefault(require("react-dropzone"));

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  border-color: ", ";\n  color: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  background: none;\n  border: 2px dashed ", ";\n  color: ", ";\n  display: block;\n  padding: 40px 20px 50px;\n  text-align: center;\n  width: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var dropzoneStyle = (0, _emotion.css)(_templateObject(), colors.alloy, colors.alloy);
var dropzoneActiveStyle = (0, _emotion.css)(_templateObject2(), colors.ocean.base, colors.ocean.base);

var Dropzone =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(Dropzone, _PureComponent);

  function Dropzone() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Dropzone);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Dropzone)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "dropzoneRef", (0, _react.createRef)());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "open", function () {
      _this.dropzoneRef.current && _this.dropzoneRef.current.open();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onDrop", function (acceptedFiles) {
      var onDrop = _this.props.onDrop;
      onDrop && onDrop(acceptedFiles);
    });
    return _this;
  }

  (0, _createClass2.default)(Dropzone, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_reactDropzone.default, {
        ref: this.dropzoneRef,
        onDrop: this.onDrop
      }, function (_ref) {
        var getRootProps = _ref.getRootProps,
            getInputProps = _ref.getInputProps,
            isDragActive = _ref.isDragActive;
        var className = (0, _emotion.cx)(dropzoneStyle, (0, _defineProperty2.default)({}, dropzoneActiveStyle, isDragActive));
        return _react.default.createElement("button", (0, _extends2.default)({
          className: className,
          "data-testid": "dropzone",
          type: "button"
        }, getRootProps()), _react.default.createElement("input", getInputProps()), _react.default.createElement("h1", null, "Drag a file to upload"));
      });
    }
  }]);
  return Dropzone;
}(_react.PureComponent);

exports.default = Dropzone;
(0, _defineProperty2.default)(Dropzone, "propTypes", {
  onDrop: _propTypes.default.func
});